/*
 * @Description: 
 * @Autor: lishutong
 * @Date: 2020-09-17 09:19:35
 * @LastEditors: lishutong
 * @LastEditTime: 2020-09-23 11:45:34
 */
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  nickname: state => state.user.nickname
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js